<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> CATEGORIA </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-toolbar-title v-if="category.id"
          >{{ category.id }} -
          {{ category.name.toUpperCase() }}</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn outlined color="grey darken-3" @click="goToBackList()">
          <v-icon left>mdi-chevron-left</v-icon> Voltar
        </v-btn>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container fluid>
          <v-row>
            <v-col cols="12" xs="12" md="4" class="d-flex">
              <v-select
                :items="providerTypes"
                v-model="category.provider_type_id"
                label="Tipo Fornecedor"
                item-text="name"
                item-value="id"
                required
                dense
                outlined
                :rules="[rules.required]"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" md="4">
              <v-text-field
                v-model="category.name"
                class="text-field-uppercase"
                label="Nome"
                dense
                outlined
                required
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="8"> </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-switch
                v-model="category.status"
                :label="`Status: ${getLabelStatus(category.status)}`"
              ></v-switch>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn color="blue darken-3" dark class="mt-5" @click="validate">
                <v-icon left>mdi-send</v-icon> Salvar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
  </div>
</template>

<script>
import * as ProviderTypeAPI from "@/api/requests/ProviderTypeRequest";
import * as API from "@/api/requests/CategoryRequest";

export default {
  components: {},
  data: () => ({
    loading: false,
    category: {
      id: "",
      provider_type_id: "",
      name: "",
      status: 1,
    },
    providerTypes: [],
    valid: true,
    lazy: false,
    rules: {
      required: (value) => !!value || "Campo Obrigatorio",
    },
  }),
  computed: {},
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      if (this.$route.params.id) {
        this.getCategory(this.$route.params.id);
      }
      this.getProviderTypes();
    },
    async getCategory(id) {
      this.loading = true;
      try {
        this.category = await API.getById(id);
      } catch (error) {
        this.category = {};
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async getProviderTypes() {
      this.loading = true;
      this.providerTypes = [];
      try {
        let res = await ProviderTypeAPI.getAll();
        let data = res;
        this.providerTypes = data.sort((a, b) => (a.name > b.name ? 1 : -1));
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    goToBackList() {
      this.$router.push({ name: "Category" });
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.category.name = this.category.name.toUpperCase();
        this.category.status = this.category.status ? 1 : 0;
        // let data = new URLSearchParams(this.category);
        let data = { ...this.category };
        if (this.category.id === "") {
          this.post(data);
        } else {
          this.update(this.category.id, data);
        }
      }
    },
    async post(data) {
      // this.showLoading();
      this.loading = true;
      try {
        await API.post(data);
        this.goToBackList();
      } catch (error) {
        console.log(error);
        // this.showAlert({ message: error.message, type: "error" });
      } finally {
        this.loading = false;
        // this.hideLoading();
      }
    },
    async update(id, data) {
      this.loading = true;
      try {
        await API.update(id, data);
        this.goToBackList();
      } catch (error) {
        console.log(error);
        // this.showAlert({ message: error.message, type: "error" });
      } finally {
        this.loading = false;
        // this.hideLoading();
      }
    },
    getLabelStatus(status) {
      return status == 1 ? "Ativo" : "Desativado";
    },
  },
};
</script>
<style>
.text-field-uppercase input {
  text-transform: uppercase;
}
</style>
